export default __webpack_public_path__ + "static/media/WheelAwardSound.cdad8b3c.mp3";